const RevenueActionTypes = {
  SET_PAYMENTS: 'SET_PAYMENTS',
  REMOVE_PAYMENT: 'REMOVE_PAYMENT',
  SET_REVERSED_PAYMENTS: 'SET_REVERSED_PAYMENTS',
  SET_REVISED_PAYMENTS: 'SET_REVISED_PAYMENTS',
};

export default RevenueActionTypes;
